@if (!loading) {
  <div class="routed-component-layout">
    <div class="routed-component-body">
      <div class="routed-component-title-block">
        <h2>{{ (inEarlyAccessPhase ? "REGISTRATION.APPLICANT_PRE_DOTFILE_PAGE.EPA_TITLE" : "REGISTRATION.APPLICANT_PRE_DOTFILE_PAGE.TITLE") | translate }}</h2>
        <div class="image docuploadimage"></div>
        <p><strong>{{ (inEarlyAccessPhase ? "REGISTRATION.APPLICANT_PRE_DOTFILE_PAGE.EPA_SUBTITLE_1" : "REGISTRATION.APPLICANT_PRE_DOTFILE_PAGE.SUBTITLE_1") | translate }}</strong></p>
      </div>

      @if (!inEarlyAccessPhase) {
        <div id="dotfileStandardCopy" class="paragraph-group-layout">
          <p>{{ 'REGISTRATION.APPLICANT_PRE_DOTFILE_PAGE.PARAGRAPH_1_' + textLabel | translate }}</p>
          <p [innerHTML]="'REGISTRATION.APPLICANT_PRE_DOTFILE_PAGE.PARAGRAPH_2_' + textLabel | translate"></p>
          <p>{{ 'REGISTRATION.APPLICANT_PRE_DOTFILE_PAGE.PARAGRAPH_3' | translate }}</p>
        </div>
      } @else {
        <div id="dotfileEpaCopy" class="paragraph-group-layout">
          <p>{{ 'REGISTRATION.APPLICANT_PRE_DOTFILE_PAGE.EPA_PARAGRAPH_1_' + textLabel | translate }}</p>
          <p><strong>{{ 'REGISTRATION.APPLICANT_PRE_DOTFILE_PAGE.EPA_SUBTITLE_2_' + textLabel | translate }}</strong></p>
          <p>{{ 'REGISTRATION.APPLICANT_PRE_DOTFILE_PAGE.EPA_PARAGRAPH_2_' + textLabel | translate }}</p>
          <p [innerHTML]="'REGISTRATION.APPLICANT_PRE_DOTFILE_PAGE.EPA_PARAGRAPH_3' | translate"></p>
        </div>
      }

      <div class="idv-cta-section">
        @if (verificationPortalLinkAvailable()) {
          <button
            data-cy="IDV_Button_VerificationPortalButton"
            class="primary centered"
            (click)="proceedToVerificationPortal()">
            {{ "REGISTRATION.APPLICANT_PRE_DOTFILE_PAGE.CTA" | translate }}
          </button>
        } @else {
          <div class="callout warning">
            <div class="callout-content">
              {{ "REGISTRATION.APPLICANT_PRE_DOTFILE_PAGE.LINK_NOT_READY" | translate}}
            </div>
          </div>
        }
      </div>

      <p [innerHTML]="'REGISTRATION.APPLICANT_PRE_IDV_PAGE.HELP_PARAGRAPH' | translate : {idvHelpPageUrl, privacyPolicyLink}"></p>

      @if (!inEarlyAccessPhase) {
        <div id="dotfileStandardClosing">
          <p><strong>{{ "REGISTRATION.APPLICANT_PRE_DOTFILE_PAGE.SUBTITLE_2" | translate }}</strong></p>
          <p>{{ "REGISTRATION.APPLICANT_PRE_DOTFILE_PAGE.PARAGRAPH_4_" + textLabel | translate }}</p>
        </div>
      }
    </div>
  </div>
}
